import { buildStyleFns } from '../buildStyleFns';
export const borderWidthStyleFnConfigs = [
    {
        name: 'borderWidth',
        properties: ['borderWidth'],
        system: 'none',
    },
    {
        name: 'borderTopWidth',
        properties: ['borderTopWidth'],
        system: 'none',
    },
    {
        name: 'borderRightWidth',
        properties: ['borderRightWidth'],
        system: 'none',
    },
    {
        name: 'borderBottomWidth',
        properties: ['borderBottomWidth'],
        system: 'none',
    },
    {
        name: 'borderLeftWidth',
        properties: ['borderLeftWidth'],
        system: 'none',
    },
    {
        name: 'borderInlineStartWidth',
        properties: ['borderInlineStartWidth'],
        system: 'none',
    },
    {
        name: 'borderInlineEndWidth',
        properties: ['borderInlineEndWidth'],
        system: 'none',
    },
];
export const borderWidthFns = buildStyleFns(borderWidthStyleFnConfigs);
